import SvgIcon from '@mui/material/SvgIcon';
import * as React from 'react';
const SvgAngleLeft = (props)=>/*#__PURE__*/ React.createElement(SvgIcon, {
        ...props,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "m13.69 17.266-4.471-4.75a.75.75 0 0 1 0-1.031l4.472-4.75a.75.75 0 0 1 1.09 1.031l-4.013 4.235 4.012 4.234a.75.75 0 1 1-1.09 1.031"
    }));
export default SvgAngleLeft;
